<!-- Navアイテム並び替え完了ボタン -->
<template>
  <button class="crly-a-contents-complete-btn" @click="clickCompleteBtn">
    {{ $t("headerNav.btn.complete") }}
  </button>
</template>

<script>
export default {
  name: "CrlyAtomsContentsCompleteBtn",
  methods: {
    clickCompleteBtn() {
      this.$store.commit("menuStatus/setCategoryMenu", false);
      this.$emit("clickCompleteBtn");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/contents/completeBtn.scss";
</style>
